import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2380773144/src/src/app/ui/common/side-menu.tsx");
